import * as React from 'react';
import {
  ImageList,
  ImageListItem,
  ImageListItemBar,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { reverse } from 'named-urls';
import { routes } from '../../Routes';
import { simpleDateFormat } from '../../Helpers';
import { TApiChemicalProductEntity } from '../../types/Chemical';
import { useChemicalListStyles } from './ChemicalList.styles';
import Image from '../cms/Image';
import { useMediaQuery, useTheme } from '@mui/material';

interface IChemicalListProps {
  chemicals?: Array<TApiChemicalProductEntity>;
}

const ChemicalList: React.FC<IChemicalListProps> = ({
  chemicals,
}): JSX.Element => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('md'));
  const classes = useChemicalListStyles({});

  return (
    <ImageList rowHeight={180} cols={isXs ? 2 : 4} className={classes.gridList}>
      {(chemicals ?? []).map((chemical) => {
        return (
          <ImageListItem key={chemical.id}>
            <Link
              to={reverse(routes.chemicalProduct, {
                productId: chemical.id,
              })}
            >
              {chemical.image ? (
                <Image
                  image={{
                    url: chemical.image as string,
                    name: chemical.name as string,
                  }} tileImage={true}
                />
              ) : (
                <div style={{ textAlign: 'center' }}>
                  <i
                    className='fas fa-flask'
                    style={{ fontSize: '150px', color: 'lightgray' }}
                  />
                </div>
              )}

              <ImageListItemBar
                title={chemical.name}
                subtitle={simpleDateFormat(chemical.revisedDate)}
              />
            </Link>
          </ImageListItem>
        );
      })}
    </ImageList>
  );
};

export default ChemicalList;
